import "./public.efeabce5.js";
import "./public.ac8af5d2.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire64a6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire64a6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eHZBg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab54dd51dd22c758$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $7Yi7V = parcelRequire("7Yi7V");

var $47gLI = parcelRequire("47gLI");

var $jCH6j = parcelRequire("jCH6j");

var $8Qhlh = parcelRequire("8Qhlh");
// Shared submission-render plumbing: fetches the per-marc reference,
// pulls strokes either from `item.strokesBlob` (Mine, IndexedDB) or
// `item.strokesUrl` (gallery / admin), rasterizes them once to a PNG
// data URL, and merges the blob's optional `overrides` bag (creative
// mode) over the canonical reference values. Callers wire the returned
// values into their own JSX.
async function $ab54dd51dd22c758$var$rasterizeStrokes(strokes, palette) {
    const canvas = document.createElement("canvas");
    canvas.width = (0, $7Yi7V.CANVAS_WIDTH);
    canvas.height = (0, $7Yi7V.CANVAS_HEIGHT);
    const ctx = canvas.getContext("2d");
    for (const s of strokes)(0, $47gLI.renderStroke)(ctx, s, palette);
    return canvas.toDataURL("image/png");
}
function $ab54dd51dd22c758$export$2e2bcd8739ae039(item) {
    const { reference: reference } = (0, $8Qhlh.default)(item.marcId, false);
    const [drawingSrc, setDrawingSrc] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [overrides, setOverrides] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Deserialized strokes + palette stick around so the composite-action
    // menu can re-render through the shared composite renderer instead of
    // re-deserializing on download.
    const [strokes, setStrokes] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [palette, setPalette] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let cancelled = false;
        const handle = async (blob)=>{
            if (cancelled || !blob) return;
            const deserialized = await (0, $jCH6j.deserializeStrokes)(blob.strokes || []);
            if (cancelled) return;
            setOverrides(blob.overrides ?? null);
            setStrokes(deserialized);
            setPalette(blob.palette || []);
            const src = await $ab54dd51dd22c758$var$rasterizeStrokes(deserialized, blob.palette || []);
            if (!cancelled) setDrawingSrc(src);
        };
        if (item.strokesBlob) handle(item.strokesBlob);
        else if (item.strokesUrl) fetch(item.strokesUrl).then((r)=>{
            if (!r.ok) throw new Error(`strokes ${r.status}`);
            return r.json();
        }).then(handle).catch(()=>{});
        return ()=>{
            cancelled = true;
        };
    }, [
        item.strokesBlob,
        item.strokesUrl
    ]);
    const eggTransform = overrides?.eggTransform ?? reference?.egg?.transform;
    const lights = overrides?.eggLights ?? reference?.egg?.lights ?? [];
    const warmth = overrides?.warmth ?? reference?.egg?.warmth ?? 30;
    const redshift = overrides?.redshift ?? reference?.egg?.redshift ?? 30;
    const marcTransform = overrides?.marcTransform ?? reference?.marc?.transform;
    return {
        drawingSrc: drawingSrc,
        eggTransform: eggTransform,
        lights: lights,
        warmth: warmth,
        redshift: redshift,
        marcTransform: marcTransform,
        strokes: strokes,
        palette: palette
    };
}

});


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $aRPiL = parcelRequire("aRPiL");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

var $R3rkF = parcelRequire("R3rkF");
function $2e2f539a974d869e$export$2e2bcd8739ae039(filter = "all") {
    const [entries, setEntries] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $R3rkF.listMyDrawings)());
    const [blobs, setBlobs] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let cancelled = false;
        setLoading(true);
        Promise.all(entries.map(async (e)=>[
                e.id,
                await (0, $R3rkF.getDrawingBlob)(e.id)
            ])).then((pairs)=>{
            if (cancelled) return;
            const map = {};
            for (const [id, blob] of pairs)if (blob) map[id] = blob;
            setBlobs(map);
            setLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        entries
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const refresh = ()=>setEntries((0, $R3rkF.listMyDrawings)());
        window.addEventListener("focus", refresh);
        return ()=>window.removeEventListener("focus", refresh);
    }, []);
    const items = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>entries.filter((e)=>blobs[e.id]).filter((e)=>filter === "syndicated" ? !!e.submission : true).map((e)=>({
                id: e.id,
                marcId: e.marcId,
                eggId: e.eggId,
                strokesBlob: blobs[e.id],
                source: e.source,
                submission: e.submission,
                createdAt: e.createdAt
            })), [
        entries,
        blobs,
        filter
    ]);
    return {
        items: items,
        loading: loading
    };
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $hwQVN = parcelRequire("hwQVN");

var $7Yi7V = parcelRequire("7Yi7V");

var $gLxJv = parcelRequire("gLxJv");

var $eF8WA = parcelRequire("eF8WA");

var $eHZBg = parcelRequire("eHZBg");

var $4e3Nb = parcelRequire("4e3Nb");

var $4cvDM = parcelRequire("4cvDM");

var $5Ykzn = parcelRequire("5Ykzn");

var $fOHsz = parcelRequire("fOHsz");

var $fFWQJ = parcelRequire("fFWQJ");

var $9RQES = parcelRequire("9RQES");
function $650efa072bc9ffcb$var$GalleryCard({ item: item, href: href, meta: meta, footer: footer }) {
    const eggCanvasRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const { drawingSrc: drawingSrc, eggTransform: eggTransform, lights: lights, warmth: warmth, redshift: redshift, marcTransform: marcTransform, strokes: strokes, palette: palette } = (0, $eHZBg.default)(item);
    (0, $eF8WA.default)({
        canvasRef: eggCanvasRef,
        eggSrc: (0, $4e3Nb.eggImageUrl)(item.eggId),
        eggTransform: eggTransform,
        frameW: (0, $7Yi7V.CANVAS_WIDTH),
        frameH: (0, $7Yi7V.CANVAS_HEIGHT),
        lights: lights
    });
    const [actionMenuPos, setActionMenuPos] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const compositeReady = strokes != null && palette != null;
    const compositeOpts = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            marcId: item.marcId,
            eggId: item.eggId,
            strokes: strokes,
            palette: palette,
            eggTransform: eggTransform,
            marcTransform: marcTransform,
            lights: lights,
            warmth: warmth,
            redshift: redshift
        }), [
        item.marcId,
        item.eggId,
        strokes,
        palette,
        eggTransform,
        marcTransform,
        lights,
        warmth,
        redshift
    ]);
    const handleContextMenu = (e)=>{
        if (!compositeReady) return;
        e.preventDefault();
        setActionMenuPos({
            x: e.clientX,
            y: e.clientY
        });
    };
    // Stop the link wrapper from navigating when the footer Download
    // button is clicked.
    const handleDownload = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (!compositeReady) return;
        (0, $gLxJv.downloadComposite)(compositeOpts);
    };
    const wrapperProps = href ? {
        as: "a",
        href: href
    } : {};
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($650efa072bc9ffcb$var$Card, {
        ...wrapperProps,
        onContextMenu: handleContextMenu,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($650efa072bc9ffcb$var$EggCol, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($650efa072bc9ffcb$var$FrameStage, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fFWQJ.default), {
                        width: (0, $7Yi7V.FRAME_OUTER_WIDTH),
                        height: (0, $7Yi7V.FRAME_OUTER_HEIGHT),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($650efa072bc9ffcb$var$FrameInterior, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($650efa072bc9ffcb$var$EggCanvas, {
                                        ref: eggCanvasRef,
                                        width: (0, $7Yi7V.CANVAS_WIDTH),
                                        height: (0, $7Yi7V.CANVAS_HEIGHT),
                                        style: {
                                            filter: `${(0, $fOHsz.tintFilter)(warmth, redshift)} ${(0, $fOHsz.dropShadowFilter)(lights)}`
                                        }
                                    }),
                                    drawingSrc && /*#__PURE__*/ (0, $ayMG0.jsx)($650efa072bc9ffcb$var$DrawingImg, {
                                        src: drawingSrc,
                                        alt: "",
                                        draggable: false
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($650efa072bc9ffcb$var$FrameOverlay, {
                                src: "/frame.png",
                                alt: "",
                                draggable: false
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($650efa072bc9ffcb$var$SideCol, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($650efa072bc9ffcb$var$MarcSlot, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9RQES.default), {
                            marcId: item.marcId,
                            marcTransform: marcTransform,
                            withEasel: false
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($650efa072bc9ffcb$var$MetaSlot, {
                        children: meta
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($650efa072bc9ffcb$var$FooterRow, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($650efa072bc9ffcb$var$FooterStart, {
                        children: footer
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4cvDM.default), {
                        type: "button",
                        disabled: !compositeReady,
                        onClick: handleDownload,
                        title: "Download a PNG of this Marc",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hwQVN.DownloadSimple), {
                                size: 14,
                                weight: "bold"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "Download"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ykzn.default), {
                open: actionMenuPos != null,
                onOpenChange: (next)=>{
                    if (!next) setActionMenuPos(null);
                },
                anchorPos: actionMenuPos,
                onDownload: ()=>(0, $gLxJv.downloadComposite)(compositeOpts),
                onCopy: ()=>(0, $gLxJv.copyCompositeToClipboard)(compositeOpts),
                canCopy: (0, $gLxJv.canCopyImageToClipboard)()
            })
        ]
    });
}
const $650efa072bc9ffcb$var$Card = (0, $lmFrL.default).div`
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(0, 1fr);
  gap: clamp(0.5rem, 2vw, 1rem);
  padding: clamp(0.625rem, 2vw, 1rem);
  background: var(--color-orange-100);
  border: 1px solid var(--color-orange-300);
  border-radius: 10px;
  box-shadow: var(--surface-box-shadow);
  text-decoration: none;
  color: inherit;
  aspect-ratio: 1.1 / 1;
  /* align-items: center; */

  transition:
    background-color 120ms ease-out,
    border-color 120ms ease-out;

  &:hover {
    background: var(--color-orange-200);
    border-color: var(--color-orange-400);
  }
`;
const $650efa072bc9ffcb$var$EggCol = (0, $lmFrL.default).div`
  aspect-ratio: ${(0, $7Yi7V.FRAME_OUTER_WIDTH)} / ${(0, $7Yi7V.FRAME_OUTER_HEIGHT)};
  min-width: 0;
`;
const $650efa072bc9ffcb$var$SideCol = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  min-width: 0;
`;
const $650efa072bc9ffcb$var$MarcSlot = (0, $lmFrL.default).div`
  width: 100%;
  aspect-ratio: ${(0, $7Yi7V.CANVAS_WIDTH)} / ${(0, $7Yi7V.CANVAS_HEIGHT)};
  container-type: size;
`;
const $650efa072bc9ffcb$var$FrameStage = (0, $lmFrL.default).div`
  width: 100%;
  height: 100%;
  position: relative;
  filter: drop-shadow(0 6px 10px rgba(0, 0, 0, 0.22));
`;
const $650efa072bc9ffcb$var$FrameInterior = (0, $lmFrL.default).div`
  position: absolute;
  top: ${(0, $7Yi7V.FRAME_SLICE_TOP)}px;
  left: ${(0, $7Yi7V.FRAME_SLICE_LEFT)}px;
  width: ${(0, $7Yi7V.CANVAS_WIDTH)}px;
  height: ${(0, $7Yi7V.CANVAS_HEIGHT)}px;
  background: var(--canvas-bg);
  overflow: hidden;
`;
const $650efa072bc9ffcb$var$FrameOverlay = (0, $lmFrL.default).img`
  position: absolute;
  top: 0;
  left: 0;
  width: ${(0, $7Yi7V.FRAME_OUTER_WIDTH)}px;
  height: ${(0, $7Yi7V.FRAME_OUTER_HEIGHT)}px;
  pointer-events: none;
  user-select: none;
`;
const $650efa072bc9ffcb$var$EggCanvas = (0, $lmFrL.default).canvas`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
`;
const $650efa072bc9ffcb$var$DrawingImg = (0, $lmFrL.default).img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  user-select: none;
`;
const $650efa072bc9ffcb$var$MetaSlot = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
const $650efa072bc9ffcb$var$FooterRow = (0, $lmFrL.default).div`
  grid-column: 1 / -1;
  border-top: 1px solid var(--color-orange-300);
  padding-top: 0.625rem;
  margin-top: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
`;
// Holds whatever the parent passed as `footer`. Empty when no footer
// content is supplied (Mine tab) — the Download button still right-
// aligns via FooterRow's space-between.
const $650efa072bc9ffcb$var$FooterStart = (0, $lmFrL.default).div`
  min-width: 0;
`;
var $650efa072bc9ffcb$export$2e2bcd8739ae039 = $650efa072bc9ffcb$var$GalleryCard;




const $61e3bf5bb418e887$var$MARC_HASH_RE = /^#?(\d{3})$/;
function $61e3bf5bb418e887$var$readMarcFilter() {
    const m = $61e3bf5bb418e887$var$MARC_HASH_RE.exec(window.location.hash);
    return m ? m[1] : null;
}
function $61e3bf5bb418e887$var$readPermalinkId() {
    return new URLSearchParams(window.location.search).get("id");
}
function $61e3bf5bb418e887$var$clearMarcFilter(e) {
    e.preventDefault();
    // history.pushState + manual hashchange dispatch — assigning '' to
    // location.hash leaves a stray '#' in the URL bar.
    window.history.pushState(null, "", window.location.pathname);
    window.dispatchEvent(new HashChangeEvent("hashchange"));
}
function $61e3bf5bb418e887$var$setMarcFilterUrl(e, marcId) {
    e.preventDefault();
    e.stopPropagation();
    window.history.pushState(null, "", `${window.location.pathname}#${marcId}`);
    window.dispatchEvent(new HashChangeEvent("hashchange"));
}
function $61e3bf5bb418e887$var$formatDate(ms) {
    return new window.Date(ms).toLocaleDateString(undefined, {
        month: "numeric",
        day: "numeric",
        year: "2-digit"
    });
}
function $61e3bf5bb418e887$var$Gallery() {
    const [tab, setTab] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("public");
    const [mineFilter, setMineFilter] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("all");
    // Public listing: one fetch on mount. Marc-hash and ?id= permalink
    // are applied client-side over the cached results — at current
    // scale the round-trip on every hash change wasn't worth it. When
    // the gallery grows enough to need windowing, the API still
    // supports server-side filters; drop them back in then.
    const [allPublic, setAllPublic] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [publicLoading, setPublicLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [publicError, setPublicError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let cancelled = false;
        fetch("/api/gallery?limit=50").then((r)=>{
            if (!r.ok) throw new Error(`gallery fetch failed (${r.status})`);
            return r.json();
        }).then((data)=>{
            if (cancelled) return;
            setAllPublic(data.items || []);
            setPublicLoading(false);
        }).catch((e)=>{
            if (cancelled) return;
            setPublicError(e.message);
            setPublicLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, []);
    const [marcFilter, setMarcFilter] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>$61e3bf5bb418e887$var$readMarcFilter());
    const [permalinkId, setPermalinkId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>$61e3bf5bb418e887$var$readPermalinkId());
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const sync = ()=>{
            setMarcFilter($61e3bf5bb418e887$var$readMarcFilter());
            setPermalinkId($61e3bf5bb418e887$var$readPermalinkId());
        };
        window.addEventListener("hashchange", sync);
        window.addEventListener("popstate", sync);
        return ()=>{
            window.removeEventListener("hashchange", sync);
            window.removeEventListener("popstate", sync);
        };
    }, []);
    const publicItems = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (permalinkId) return allPublic.filter((i)=>i.id === permalinkId);
        if (marcFilter) return allPublic.filter((i)=>i.marcId === marcFilter);
        return allPublic;
    }, [
        allPublic,
        permalinkId,
        marcFilter
    ]);
    const { items: mineItems, loading: mineLoading } = (0, $2e2f539a974d869e$export$2e2bcd8739ae039)(mineFilter);
    const isPublic = tab === "public";
    const items = isPublic ? publicItems : mineItems;
    const loading = isPublic ? publicLoading : mineLoading;
    const error = isPublic ? publicError : null;
    let banner = null;
    if (isPublic && permalinkId) banner = /*#__PURE__*/ (0, $ayMG0.jsxs)($61e3bf5bb418e887$var$FilterChip, {
        children: [
            "Showing one egg",
            /*#__PURE__*/ (0, $ayMG0.jsx)($61e3bf5bb418e887$var$ChipDot, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                href: "/gallery",
                children: "Back to gallery"
            })
        ]
    });
    else if (isPublic && marcFilter) banner = /*#__PURE__*/ (0, $ayMG0.jsxs)($61e3bf5bb418e887$var$FilterChip, {
        children: [
            "Filtering to Marc ",
            marcFilter,
            /*#__PURE__*/ (0, $ayMG0.jsx)($61e3bf5bb418e887$var$ChipDot, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                href: "#",
                onClick: $61e3bf5bb418e887$var$clearMarcFilter,
                children: "Show all"
            })
        ]
    });
    let emptyMsg = null;
    if (!loading && !error && items.length === 0) {
        if (isPublic) emptyMsg = "no eggs yet";
        else if (mineFilter === "syndicated") emptyMsg = "You haven't syndicated yet. Be brave.";
        else emptyMsg = "You haven't shipped a Marc. The world is waiting.";
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($61e3bf5bb418e887$var$Page, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($61e3bf5bb418e887$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($61e3bf5bb418e887$var$TitleLink, {
                        href: "/",
                        children: "Our Marcs"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($61e3bf5bb418e887$var$Subtitle, {
                        children: "We Believe in Drawing Marc on Eggs, and We Built the Site that Way."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($61e3bf5bb418e887$var$TabSection, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($61e3bf5bb418e887$var$Tabs, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($61e3bf5bb418e887$var$Tab, {
                                $active: isPublic,
                                onClick: ()=>setTab("public"),
                                children: "Public Marcs"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($61e3bf5bb418e887$var$Tab, {
                                $active: !isPublic,
                                onClick: ()=>setTab("mine"),
                                children: "Private Marcs"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($61e3bf5bb418e887$var$Filters, {
                        "aria-hidden": isPublic,
                        $hidden: isPublic,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($61e3bf5bb418e887$var$Chip, {
                                $active: mineFilter === "all",
                                onClick: ()=>setMineFilter("all"),
                                children: "All"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($61e3bf5bb418e887$var$Chip, {
                                $active: mineFilter === "syndicated",
                                onClick: ()=>setMineFilter("syndicated"),
                                children: "Syndicated"
                            })
                        ]
                    })
                ]
            }),
            banner,
            loading && /*#__PURE__*/ (0, $ayMG0.jsx)($61e3bf5bb418e887$var$Status, {
                children: "loading\u2026"
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsxs)($61e3bf5bb418e887$var$Status, {
                children: [
                    "error: ",
                    error
                ]
            }),
            emptyMsg && /*#__PURE__*/ (0, $ayMG0.jsx)($61e3bf5bb418e887$var$Status, {
                children: emptyMsg
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($61e3bf5bb418e887$var$GalleryPanel, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($61e3bf5bb418e887$var$Grid, {
                    children: items.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $650efa072bc9ffcb$export$2e2bcd8739ae039), {
                            item: item,
                            href: isPublic ? `/gallery?id=${item.id}` : undefined,
                            meta: isPublic ? /*#__PURE__*/ (0, $ayMG0.jsx)($61e3bf5bb418e887$var$PublicMeta, {
                                item: item
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($61e3bf5bb418e887$var$MineMeta, {
                                item: item
                            }),
                            footer: isPublic ? /*#__PURE__*/ (0, $ayMG0.jsx)($61e3bf5bb418e887$var$MetaButton, {
                                onClick: (e)=>$61e3bf5bb418e887$var$setMarcFilterUrl(e, item.marcId),
                                children: "Comparable marcs \u2192"
                            }) : null
                        }, item.id))
                })
            })
        ]
    });
}
function $61e3bf5bb418e887$var$PublicMeta({ item: item }) {
    const mode = item.source === "speedrun" ? `Speedrun` : "Creative";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($61e3bf5bb418e887$var$MetaList, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                children: "Builder"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
                children: item.initials
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                children: "Subject"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
                children: "Marc Andreessen"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                children: "Mode"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
                children: mode
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                children: "Built"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
                children: $61e3bf5bb418e887$var$formatDate(item.createdAt)
            })
        ]
    });
}
function $61e3bf5bb418e887$var$MineMeta({ item: item }) {
    const mode = item.source === "speedrun" ? `Speedrun` : "Creative";
    const status = item.submission ? `Syndicated \xb7 ${item.submission.initials}` : "Local only";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($61e3bf5bb418e887$var$MetaList, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                children: "Subject"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
                children: "Marc Andreessen"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                children: "Mode"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
                children: mode
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                children: "Built"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
                children: $61e3bf5bb418e887$var$formatDate(item.createdAt)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                children: "Status"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
                children: status
            })
        ]
    });
}
const $61e3bf5bb418e887$var$Page = (0, $lmFrL.default).div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 2.5rem clamp(0.5rem, 3vw, 1.25rem) 4rem;
  font-family: "Nunito", system-ui, sans-serif;
`;
const $61e3bf5bb418e887$var$Header = (0, $lmFrL.default).header`
  margin-bottom: 1.5rem;
  text-align: center;
`;
const $61e3bf5bb418e887$var$TitleLink = (0, $lmFrL.default).a`
  display: inline-block;
  font-family: "Fraunces", serif;
  font-size: clamp(2.5rem, 6vw, 5rem);
  line-height: 1;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--color-text);
  text-decoration: none;
  text-shadow:
    0 1px 0 rgba(255, 255, 255, 0.5),
    0 2px 6px rgba(80, 45, 20, 0.18);

  &:hover {
    text-decoration: underline;
    text-decoration-thickness: 4px;
  }
`;
const $61e3bf5bb418e887$var$Subtitle = (0, $lmFrL.default).p`
  margin-top: 0.5rem;
  font-style: italic;
  color: var(--color-text-muted);
  font-size: clamp(0.95rem, 1.2vw, 1.125rem);
  max-width: 38rem;
  margin-left: auto;
  margin-right: auto;
  text-wrap: balance;
`;
const $61e3bf5bb418e887$var$TabSection = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
`;
const $61e3bf5bb418e887$var$Tabs = (0, $lmFrL.default).div`
  display: flex;
  align-items: flex-end;
  gap: 0.5rem 1rem;
  flex-wrap: wrap;
  border-bottom: 1px solid var(--color-orange-300);
`;
const $61e3bf5bb418e887$var$Tab = (0, $lmFrL.default).button`
  padding: 0.5rem 0.25rem;
  background: none;
  border: none;
  cursor: pointer;
  font-family: "Fraunces", serif;
  font-size: 1.125rem;
  color: var(--color-text-muted);
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  white-space: nowrap;

  ${(p)=>p.$active && (0, $lmFrL.css)`
      color: var(--color-text);
      border-bottom-color: var(--color-orange-700);
    `};
`;
const $61e3bf5bb418e887$var$Filters = (0, $lmFrL.default).div`
  display: flex;
  gap: 0.375rem;

  ${(p)=>p.$hidden && (0, $lmFrL.css)`
      visibility: hidden;
      pointer-events: none;
    `}
`;
const $61e3bf5bb418e887$var$Chip = (0, $lmFrL.default).button`
  padding: 0.25rem 0.625rem;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  border-radius: 999px;
  border: 1px solid var(--color-orange-300);
  background: ${(p)=>p.$active ? "var(--color-orange-700)" : "var(--color-orange-50, #fff8f1)"};
  color: ${(p)=>p.$active ? "white" : "var(--color-text-muted)"};
  cursor: pointer;
`;
const $61e3bf5bb418e887$var$FilterChip = (0, $lmFrL.default).div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0.875rem;
  margin-bottom: 1rem;
  border-radius: 999px;
  background: var(--color-orange-200);
  border: 1px solid var(--color-orange-300);
  font-size: 0.875rem;
  color: var(--color-text);

  a {
    color: var(--color-orange-700);
    text-decoration: underline;
    text-underline-offset: 3px;
  }
`;
const $61e3bf5bb418e887$var$ChipDot = (0, $lmFrL.default).span`
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: var(--color-text-muted);
`;
const $61e3bf5bb418e887$var$Status = (0, $lmFrL.default).div`
  padding: 2rem 0;
  color: var(--color-text-muted);
`;
const $61e3bf5bb418e887$var$GalleryPanel = (0, $lmFrL.default).div`
  /* Cream wash that softens the graph paper underneath, with a radial
     mask so the edges fade into the page. backdrop-filter blurs the
     grid lines showing through. */
  position: relative;
  padding: 1rem clamp(0.5rem, 3vw, 1.25rem) 1.25rem;
  border-radius: 24px;
  background: rgba(255, 247, 237, 0.1);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  -webkit-mask-image: radial-gradient(
    ellipse 100% 100% at center,
    black 80%,
    transparent 100%
  );
  mask-image: radial-gradient(
    ellipse 100% 100% at center,
    black 80%,
    transparent 100%
  );
`;
const $61e3bf5bb418e887$var$Grid = (0, $lmFrL.default).div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 300px), 420px));
  gap: 1.5rem;
  justify-content: center;
`;
const $61e3bf5bb418e887$var$MetaList = (0, $lmFrL.default).dl`
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 0.625rem;
  row-gap: 0.3125rem;
  margin: 0;
  font-size: 0.8125rem;
  line-height: 1.35;

  dt {
    color: var(--color-text-muted);
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-size: 0.6875rem;
    align-self: center;
  }

  dd {
    margin: 0;
    color: var(--color-text);
    font-family: "Fraunces", serif;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
const $61e3bf5bb418e887$var$MetaButton = (0, $lmFrL.default).button`
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  font-size: 0.8125rem;
  color: var(--color-orange-700);
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;

  &:hover {
    color: var(--color-orange-800);
  }
`;
var $61e3bf5bb418e887$export$2e2bcd8739ae039 = $61e3bf5bb418e887$var$Gallery;




const $beca04877cf9de62$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($aRPiL))).createRoot(document.getElementById("root"));
$beca04877cf9de62$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $61e3bf5bb418e887$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=gallery.2a3569af.js.map
